<template>
    <div id="webinar-list">
        <div class="uk-grid uk-grid-xsmall" uk-grid v-if="filteredWebinarsList.length">
            <div class="uk-width-1-1">
               
                <dr-webinar-slider
                    :webinars="upcomingWebinars"
                    :webinarItemType="getWebinarType()"
                />
                
                <h2 class="dr-past-webinars-title" v-if="pastWebinars.length" v-html="$t('message.past_webinars_title').replace('{pastCount}', pastWebinars.length)"></h2>
                <div class="dr-past-webinars uk-grid uk-grid-medium uk-margin-xlarge-bottom" uk-grid v-if="pastWebinars.length">
                    <dr-webinar-item
                        v-for="(webinarItem, webinarItemIndex) in pastWebinarsForDisplay"
                        :webinarItem="webinarItem"
                        :webinarItemType="getWebinarType(webinarItem)"
                        :key="webinarItemIndex"
                        :class="{'past-webinar': webinarItem.status === 'past'}"
                        v-if="webinarItem.status === 'past'"/>
                </div>
                
                <div class="uk-text-center" v-if="getPagesQuantity > 1">
                    <div class="uk-display-inline-block">
                        <paginate
                            v-model="pageNumber"
                            :page-count="getPagesQuantity"
                            :click-handler="onPaginateClick"
                            container-class="uk-pagination"
                            :firstLastButton="false"
                            :hidePrevNext="true"
                            next-class="uk-prev"
                            prev-class="uk-next"
                            active-class="uk-active"
                            page-class="dr-pagination-item"
                            disabled-class="uk-disabled">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import WebinarItem from "./Webinar-item.vue";
    import WebinarSlider from "./Webinar-slider.vue";
    import { mapGetters } from "vuex"
    import Paginate from 'vuejs-paginate'
    import UIkit from 'uikit'

    export default {
        name: "Webinar-list",
        components: {
            'dr-webinar-item': WebinarItem,
            'dr-webinar-slider': WebinarSlider,
            'paginate': Paginate
        },
        computed: {
            ...mapGetters([
                'getFilteredWebinarsList',
                'webinarsList',
                'currentPage',
                'getUpcomingWebinars',
                'getPastWebinars'
            ]),
            filteredWebinarsList() {
                return this.getFilteredWebinarsList;
            },
            upcomingWebinars() {
                return this.getUpcomingWebinars;
            },
            pastWebinars() {
                return this.getPastWebinars;
            },
            getPagesQuantity() {
                return Math.ceil(this.filteredWebinarsList.length / this.itemsForPage);
            },
            paginatedData(){
                this.pageNumber = this.currentPage !== this.pageNumber ? this.currentPage : this.pageNumber;
                const start = (this.pageNumber - 1) * this.itemsForPage;
                const end = start + this.itemsForPage;
                return this.filteredWebinarsList.slice(start, end);
            },
            upcomingWebinarsForDisplay() {
                return this.paginatedData.filter(webinar => webinar.status === 'upcoming');
            },
            pastWebinarsForDisplay() {
                return this.paginatedData.filter(webinar => webinar.status === 'past');
            }
        },
        data () {
            return {
                pageNumber: 1,
                itemsForPage: 10
            }
        },
        methods: {
            onPaginateClick() {
                this.$store.dispatch('setPageParams', this.pageNumber);
                UIkit.scroll('.dr-pagination-item').scrollTo('#webinar-list');
            },
            getWebinarType(webinarItem) {
                return 'webinar';
            },
            clearFilters() {
                this.$store.dispatch('clearAllFilters');
            }
        }
    }
</script>

<style lang="scss">
    @import "assets/src/scss/misc/mixins";
    @import "assets/src/scss/uikit-theme/variables";
    
    .dr-past-webinars {

		&-title {
			display: block;
			color: #a2a2a2;
			text-align: left;
			font-size: 18px;
		}
	}
</style>
